import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const InvitationGroupsSecondaryViewStore = GenericFieldFactory("INVITATION_GROUPS_SECONDARY_VIEW", null)

